import { init } from '@sentry/angular';
export const SENTRY_CONFIG = {
  enabled: true,
  dsn: 'https://6903c038479dfb4e63adc6313c39d5bd@o4505792581140480.ingest.us.sentry.io/4510775874158592',
  environment: 'production',
  release: 'cp-warranty-fe@1.0.0',
};

export function initSentry() {
  // Chỉ khởi tạo Sentry nếu được enable trong environment
  if (!SENTRY_CONFIG.enabled) {
    console.warn('Sentry is disabled in environment');
    return;
  }

  // Kiểm tra DSN có hợp lệ không
  if (!SENTRY_CONFIG.dsn || SENTRY_CONFIG.dsn === 'YOUR_SENTRY_DSN_HERE') {
    console.error('❌ Sentry DSN is not configured properly');
    console.error('Please update DSN in environment files');
    return;
  }

  try {
    init({
      dsn: SENTRY_CONFIG.dsn,
      environment: SENTRY_CONFIG.environment,
      // Bật debug mode để kiểm tra lỗi
      debug: true,
    // Tỷ lệ sampling cho performance monitoring (0.0 - 1.0)
    tracesSampleRate: 1.0,
    // Tỷ lệ sampling cho error reporting
    sampleRate: 1.0,
    // Cấu hình release
    release: 'cp-warranty-fe@1.0.0',
    // Cấu hình để capture HTTP request data
    integrations: [
      // Sử dụng default integrations - BrowserTracing sẽ được tự động thêm
    ],
    // Cấu hình beforeSend để lọc hoặc modify errors
    beforeSend(event, hint) {
      // Lọc ra các error không quan trọng
      if (event.exception) {
        const error = hint.originalException;
        if (error && (error as any).name === 'ChunkLoadError') {
          return null; // Bỏ qua chunk load errors
        }
      }
      
      // Ignore 401 Unauthorized errors
      if (event.contexts && event.contexts.http_response && event.contexts.http_response.status === 401) {
        console.log('Ignoring 401 Unauthorized error in Sentry');
        return null;
      }
      
      // Ignore 401 errors từ HTTP requests
      if (event.tags && event.tags.http_status === '401') {
        console.log('Ignoring 401 HTTP error in Sentry');
        return null;
      }
      
      // Log để debug - kiểm tra xem body có được capture không
      if (event.contexts && event.contexts.http_request) {
        console.log('Sentry capturing HTTP request:', {
          method: event.contexts.http_request.method,
          url: event.contexts.http_request.url,
          hasBody: !!event.contexts.http_request.body,
          body: event.contexts.http_request.body
        });
      }
      
      return event;
    },
    // Cấu hình tags và context
    initialScope: {
      tags: {
        component: 'cp-warranty-fe',
      },
      contexts: {
        runtime: {
          name: 'browser',
        },
      },
    },
  });
  } catch (error) {
    console.error('❌ Failed to initialize Sentry:', error);
    console.error('Please check your DSN configuration');
  }
}
